import { Save } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const SaveIcon = createLucideIcon(Save);
